<!-- <h2 mat-dialog-title>{{ isNew ? 'Tambah' : 'Ubah' }} Riwayat {{ title }}</h2> -->
<div mat-dialog-content class="riwayat">
    <div class="row">
        <div class="row flex padding-top-12 padding-bottom-12">
            <span class="dialog-title">Detail</span>
        </div>
    </div>
    <div class="row">

        <div *ngIf="isGolongan" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="Golongan" [fc]="golonganForm" [options]="golongans" inputType="select"
                    [displayOptionsMode]="DisplayOptionsMode.CODE">
                </tr>
                <tr app-tr label="Jenis Kenaikan Pangkat (KP)" [fc]="jenisForm" [options]="jenisKenpas"
                    inputType="select"></tr>
                <tr app-tr label="TMT Golongan" [fc]="tanggalTmtForm" inputType="date"></tr>
                <tr app-tr label="Nomor Surat Keputusan (SK)" [fc]="skForm"></tr>
                <tr app-tr label="Tanggal Surat Keputusan (SK)" [fc]="tanggalSkForm" inputType="date"></tr>
                <tr app-tr label="Nomor Pertek BKN" [fc]="pertekForm"></tr>
                <tr app-tr label="Tanggal Pertek BKN" [fc]="tanggalPertekForm" inputType="date"></tr>
            </table>
            <!-- <table class="table padding-top-12 full-width">
                <mat-form-field>
                    <mat-label>Golongan</mat-label>
                    <mat-select [formControl]="golonganForm" ngDefaultControl required="true">
                        <mat-option *ngFor="let item of golongans" [value]="item.id">
                            {{ item.code }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Jenis Kenaikan Pangkat (KP)</mat-label>
                    <input matInput [formControl]="jenisForm" />
                    <mat-error *ngIf="jenisForm.invalid">{{
                        FormUtils.getErrorMessage(skForm)
                        }}</mat-error>
                </mat-form-field>

                <tr app-tr label="TMT Golongan" [fc]="tanggalTmtForm" inputType="date"></tr>

                <mat-form-field>
                    <mat-label>Nomor Surat Keputusan (SK)</mat-label>
                    <input matInput [formControl]="skForm" />
                    <mat-error *ngIf="skForm.invalid">{{
                        FormUtils.getErrorMessage(skForm)
                        }}</mat-error>
                </mat-form-field>

                <tr app-tr label="Tanggal Surat Keputusan (SK)" [fc]="tanggalSkForm" inputType="date"></tr>
                <mat-form-field>
                    <mat-label>Nomor Pertek BKN</mat-label>
                    <input matInput [formControl]="pertekForm" />
                    <mat-error *ngIf="pertekForm.invalid">{{
                        FormUtils.getErrorMessage(pertekForm)
                        }}</mat-error>
                </mat-form-field>
                <tr app-tr label="Tanggal Pertek BKN" [fc]="tanggalPertekForm" inputType="date"></tr>
            </table> -->
        </div>
        <div *ngIf="isPendidikan" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="Tingkat Pendidikan" [fc]="tingkatForm" [options]="tingkats" inputType="select">
                </tr>
                <tr app-tr label="Pendidikan" [fc]="nameForm"></tr>
                <tr app-tr label="Nama Sekolah/Universitas/Institusi" [fc]="instansiForm">
                </tr>
                <tr app-tr label="Tanggal Tahun Lulus" [fc]="tanggalTmtForm" inputType="date"></tr>
                <tr app-tr label="Nomor Ijazah" [fc]="noForm"></tr>
                <tr app-tr label="Gelar Depan" [fc]="gelarDepanForm"></tr>
                <tr app-tr label="Gelar Belakang" [fc]="gelarBelakangForm"></tr>
                <tr app-tr label="Pendidikan Ke" [fc]="pertamaForm">
                </tr>
            </table>
        </div>
        <div *ngIf="isJabatan" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="Jenis Jabatan" [fc]="jenisJabatanForm" [options]="jenisJabatans" inputType="select">
                </tr>
                <tr app-tr label="Instansi" [fc]="instansiForm"></tr>
                <tr app-tr label="Satuan Kerja" [fc]="satuanKerjaForm"></tr>
                <tr app-tr label="Unor" [fc]="unorForm"></tr>
                <tr app-tr label="Jabatan" [fc]="jabFungUmumForm" [options]="jabatans" inputType="select">
                </tr>
                <tr app-tr label="TMT Jabatan" [fc]="tanggalTmtForm" inputType="date"></tr>
                <tr app-tr label="TMT Pelantikan" [fc]="tanggalTmt2Form" inputType="date"></tr>
                <tr app-tr label="Nomor Surat Keputusan (SK)" [fc]="skForm"></tr>
                <tr app-tr label="Tanggal Surat Keputusan (SK)" [fc]="tanggalSkForm" inputType="date"></tr>
            </table>
        </div>
        <div *ngIf="isPns" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="Status Kepegawaian" [fc]="statusKepegawaianForm" [options]="statusPegawais"
                    inputType="select">
                </tr>
                <tr app-tr label="Nomor Surat Keputusan CPNS" [fc]="skForm"></tr>
                <tr app-tr label="Nomor Surat tanda tamat Pendidikan dan Latihan (STTPL)" [fc]="noSttplForm"></tr>
                <tr app-tr label="Karpeg" [fc]="karpegForm"></tr>
                <tr app-tr label="Nomor Surat Dokter" [fc]="noSurat1Form"></tr>
                <tr app-tr label="Nomor Surat Pernyataan Melaksanakan Tugas (SPMT)" [fc]="noSurat2Form"></tr>
                <tr app-tr label="Nomor Pertek C2TH" [fc]="pertekForm"></tr>
                <tr app-tr label="Tanggal Surat Keputusan CPNS" [fc]="tanggalSkForm" inputType="date"></tr>
                <tr app-tr label="Tanggal Surat Keputusan PNS" [fc]="tanggalSk2Form" inputType="date"></tr>
                <tr app-tr label="Tanggal Surat tanda tamat Pendidikan dan Latihan (STTPL)" [fc]="tanggalSttplForm"
                    inputType="date"></tr>
                <tr app-tr label="TMT CPNS" [fc]="tanggalTmtForm" inputType="date"></tr>
                <tr app-tr label="TMT PNS" [fc]="tanggalTmt2Form" inputType="date"></tr>
                <tr app-tr label="Tanggal Dokter" [fc]="tanggalSuratForm" inputType="date"></tr>
                <tr app-tr label="Tanggal Pertek C2TH" [fc]="tanggalPertekForm" inputType="date"></tr>
            </table>
        </div>

        <div *ngIf="isSkp" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="Tahun" [fc]="tahunForm"></tr>
                <tr app-tr label="Nilai SKP" [fc]="nilaiSkpForm" inputType="number"></tr>
                <tr app-tr label="Orientasi Pelayanan" [fc]="orientasiPelayananForm" inputType="number"></tr>
                <tr app-tr label="Integritas" [fc]="integritasForm" inputType="number"></tr>
                <tr app-tr label="Komitmen" [fc]="komitmenForm" inputType="number"></tr>
                <tr app-tr label="Disiplin" [fc]="disiplinForm" inputType="number"></tr>
                <tr app-tr label="Kerja sama" [fc]="kerjaSamaForm" inputType="number"></tr>
                <tr app-tr label="Kepemimpinan" [fc]="kepemimpinanForm" inputType="number"></tr>
                <tr app-tr label="Jumlah" [fc]="jumlahForm" inputType="number"></tr>
                <tr app-tr label="Nilai perilaku kerja" [fc]="perilakuKerjaForm" inputType="number"></tr>
                <tr app-tr label="Nilai prestasi kerja" [fc]="prestasiKerjaForm" inputType="number"></tr>
                <tr app-tr label="Atasan Non PNS Id" [fc]="atasanNonPnsForm"></tr>
                <tr app-tr label="Atasan Jabatan" [fc]="atasanJabatanForm" [options]="jabatans" inputType="select">
                </tr>
                <tr app-tr label="Penilai Jabatan" [fc]="penilaiJabatanForm" [options]="jabatans" inputType="select">
                </tr>
                <tr app-tr label="Penilai golongan" [fc]="penilaiGolonganForm" [options]="golongans" inputType="select"
                    [displayOptionsMode]="DisplayOptionsMode.CODE"></tr>
                <tr app-tr label="Atasan golongan" [fc]="atasanGolonganForm" [options]="golongans" inputType="select"
                    [displayOptionsMode]="DisplayOptionsMode.CODE"></tr>

                <tr app-tr label="Atasan Unor Nama" [fc]="atasanUnorNamaForm"></tr>
                <tr app-tr label="Penilai Unor Nama" [fc]="penilaiUnorNamaForm"></tr>

                <tr app-tr label="Atasan Nama" [fc]="atasanNamaForm"></tr>
                <tr app-tr label="Penilai Nama" [fc]="penilaiNamaForm"></tr>

                <tr app-tr label="Atasan NIP" [fc]="atasanNipForm"></tr>
                <tr app-tr label="Penilai NIP" [fc]="penilaiNipForm"></tr>

                <tr app-tr label="Status Atasan" [fc]="atasanStatusForm" [options]="statusPegawais" inputType="select">
                </tr>
                <tr app-tr label="Status Penilai" [fc]="penilaiStatusForm" [options]="statusPegawais"
                    inputType="select"></tr>
                <tr app-tr label="Jenis Jabatan" [fc]="jenisJabatanForm" [options]="jenisJabatans" inputType="select">
                </tr>
                <tr app-tr label="Penilai TMT golongan" [fc]="tanggalTmtForm" inputType="date"></tr>
                <tr app-tr label="Atasan TMT golongan" [fc]="tanggalTmt2Form" inputType="date"></tr>
            </table>
        </div>

        <div *ngIf="isKGB" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="TMT" [fc]="tanggalTmtForm" inputType="date"></tr>
                <tr app-tr label="Usulan" [fc]="tanggalTmt2Form" inputType="date"></tr>
            </table>
        </div>
        <div *ngIf="isBUP" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="Usulan" [fc]="tanggalTmt2Form" inputType="date"></tr>
            </table>
        </div>
        <div *ngIf="isSatyaLencana" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="Satya Lencana" [fc]="tahun2Form" inputType="select" [options]="tahunOption"></tr>
                <tr app-tr label="Tahun" [fc]="tahunForm" inputType="number"></tr>
            </table>
        </div>
        <div *ngIf="isKeluarga" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="Hubungan" [fc]="hubunganForm" [options]="hubungans" inputType="select">
                </tr>
                <tr app-tr label="Nama" [fc]="nameForm"></tr>
                <tr app-tr label="Tanggal Lahir" [fc]="tanggalTmtForm" inputType="date"></tr>
            </table>
        </div>
        <div *ngIf="isKarisKarsu" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="Nomor Karis/Karsu" [fc]="noForm"></tr>
                <tr app-tr label="Nama" [fc]="nameForm"></tr>
                <tr app-tr label="TMT" [fc]="tanggalTmtForm" inputType="date"></tr>
                <tr app-tr label="Status" [fc]="noteForm"></tr>
            </table>
        </div>
        <div *ngIf="isPenghargaan" class="row">
            <table class="table padding-top-12 full-width">
                <tr app-tr label="Jenis Penghargaan" [fc]="jenisPenghargaanForm" [options]="jenisPenghargaans"
                    inputType="select"></tr>
                <tr app-tr label="Nama Penghargaan" [fc]="penghargaanForm" [options]="penghargaans" inputType="select">
                </tr>
                <tr app-tr label="Tahun" [fc]="tahunForm"></tr>
            </table>
        </div>
    </div>
    <div class="row">
        <div class="row flex">
            <span class="dialog-title">Dokumen</span>
        </div>
    </div>
    <div class="row"
        *ngIf="data.isEditable && (tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin())">
        <div class="row flex padding-top-12 padding-bottom-12">
            <div class="form-group">
                <input *ngIf="!isUploading" [formControl]="uploadFileForm" type="file" class="btn-primary"
                    multiple="multiple" (change)="selectFile($event)" accept=".pdf" />
            </div>
        </div>
        <mat-progress-bar mode="buffer" *ngIf="isUploading"></mat-progress-bar>
    </div>
    <div class="row">
        <div class="row flex">
            <table class="table table-striped padding-top-12" style="width: 100%;">
                <thead>
                    <tr>
                        <th class="th-padding">No</th>
                        <th class="th-padding">Nama Dokumen</th>
                        <th class="th-padding">Aksi</th>
                    </tr>
                </thead>
                <tbody *ngIf="!data.data.lampiran || data.data.lampiran.length === 0">
                    <tr>
                        <td colspan="3" class="center-col padding-top-12 padding-bottom-12">Tidak Ada Dokumen</td>
                    </tr>
                </tbody>
                <tbody *ngIf="data.data.lampiran && data.data.lampiran.length > 0">
                    <tr *ngFor="let attachment of data.data.lampiran; let index = index;">
                        <td class="th-padding">{{ (index + 1) }}.</td>
                        <td class="th-padding">{{ attachment.filename }}</td>
                        <td>
                            <div class="flex">
                                <button mat-icon-button matTooltip="View" matTooltipPosition="above"
                                    (click)="preview('', downloadService.downloadUrl(1, attachment.filepath!))">
                                    <mat-icon>remove_red_eye</mat-icon>
                                </button>
                                <button
                                    *ngIf="data.isEditable && (tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin())"
                                    mat-icon-button matTooltip="Hapus" matTooltipPosition="above"
                                    (click)="confirmDialog(attachment)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close *ngIf="!isLoading">{{ data.isEditable &&
        (tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin()) ? 'Batal' : 'OK' }}</button>
    <button mat-raised-button cdkFocusInitial color="primary"
        *ngIf="!isLoading && data.isEditable && (tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin())"
        (click)="onSubmit()">
        Simpan
    </button>
    <div class="row">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
</div>